export class CoachReasoning {
}
